<template>
  <div>
    <v-layout row>
      <v-flex xs12>
        <v-text-field
          label="Skriv inn passord"
          v-model="password"
          :append-icon="show ? 'visibility' : 'visibility_off'"
          :type="show ? 'text' : 'password'"
          :hint="numCharacters ? ('Minst ' + this.numCharacters + ' tegn') : ''"
          :rules="numCharacters ? [this.rules.numCharacters] : []"
          @keyup="passwordChanged"
          @click:append="show = !show"
        ></v-text-field>
      </v-flex>
      <v-flex>
        <v-btn flat @click="generatePassword">
          <v-icon>update</v-icon>
          Generer
        </v-btn>
      </v-flex>
    </v-layout>

    <v-text-field
      v-if="confirm"
      label="Skriv passordet igjen"
      v-model="password2"
      type="password"
      hint="Skriv det samme passordet to ganger"
      :rules=[this.rules.confirm]
      @keyup="passwordChanged"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  props: {
    confirm: Boolean,
    numCharacters: Number
  },
  data () {
    return {
      show: false,
      password: '',
      password2: '',
      rules: {
        numCharacters: v => {
          return v.length >= this.numCharacters || ('Minst ' + this.numCharacters + ' tegn.')
        },
        confirm: v => {
          return v === this.password || 'Passordene er forskjellige'
        }
      }
    }
  },
  methods: {
    passwordChanged (v) {
      if (this.numCharacters && this.password.length < this.numCharacters) {
        this.$emit('passwordChanged', '', this.password.length > 0)
      } else if (this.confirm && this.password !== this.password2) {
        this.$emit('passwordChanged', '', true)
      } else {
        this.$emit('passwordChanged', this.password, false)
      }
    },
    generatePassword () {
      const numCharacters = this.numCharacters || 8
      const pool = 'abcdefghjkmnpqrstuvwxyzABCDEFGHKMNPQRSTUVWXYZ23456789'

      let password = ''
      while (password.length <= numCharacters) {
        password += pool.charAt(Math.floor(Math.random() * pool.length))
      }

      this.password = password
      this.password2 = password
      this.show = true

      this.$emit('passwordChanged', password)
    }
  }
}
</script>
